import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { OccTokenGenerationAdapter } from './adapters/impl/occ-token-generation.adapter';
import { TokenGenerationAdapter } from './adapters/token-generation.adapter';

@NgModule({ imports: [CommonModule], providers: [
        {
            provide: TokenGenerationAdapter,
            useClass: OccTokenGenerationAdapter,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class OccModule {}
